module.exports = __webpack_public_path__ + "img/new-404-picture.8d67a316.png";